import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { action } from 'satcheljs/lib/legacy';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';

export default action('changeTotalClassicAttachmentSize')(function changeTotalClassicAttachmentSize(
    attachmentWell: AttachmentWellViewState,
    offset: number,
    attachmentId: AttachmentId
) {
    attachmentWell.totalClassicAttachmentSize += offset;
});
